// reference: https://medium.com/type-faster/js-media-queries-md-a18b41a9a28e
// author: Ronald Suez
import React from 'react'
import PropTypes from 'prop-types'
class MediaListener extends React.Component {
  state = { currentValue: null }
  mediaQueryLists = []

  _handler = () => this.setState({ currentValue: this._getValue() })

  _getValue = () => {
    const { values, defaultValue } = this.props
    // Get index of first media query that matches
    const index = this.mediaQueryLists.findIndex(mql => {
      return mql.matches
    })
    // Return related value or defaultValue if none
    return typeof values[index] !== 'undefined' ? values[index] : defaultValue
  }

  componentDidMount () {
    const { queries } = this.props
    queries.forEach((q, key) => {
      let mql = window.matchMedia(q)
      mql.breakpoint = queries[key]
      mql.name = q
      mql.addListener(this._handler)
      this.mediaQueryLists.push(mql)
    })

    this._handler()
  }

  componentWillUnmount () {
    this.mediaQueryLists.forEach(mql => mql.removeListener(this._handler))
  }

  render () {
    const { currentValue } = this.state
    const { children } = this.props
    return children({ currentValue })
  }
}

MediaListener.defaultProps = {
  queries: ['(min-width: 1024px)', '(min-width: 768px)', '(min-width: 230px)'],
  values: ['25%', '50%', '100%'],
  defaultValue: '30%'
}

MediaListener.propTypes = {
  children: PropTypes.any,
  defaultValue: PropTypes.any,
  queries: PropTypes.array,
  values: PropTypes.array
}

export default MediaListener